export default {
  common: {
    login: 'ログイン',
    logout: 'ログアウト',
    support: 'サポート',
    privacy: 'プライバシーポリシー',
    terms: `利用規約`,
    and: 'と',
    guest: 'ゲスト',
    play: 'プレイ',
    install: 'インストール',
  },
  support: {
    title: `サポートが必要ですか？`,
    description: `本ゲームを利用するうえで何かお困りの点がありましたら、
      お気軽にお問い合わせください`,
    button: '@:common.support',
  },
  homescapes: {
    title: 'ホームスケイプ',
    caption: '執事のオースティンが家族の住むお屋敷に温かさと快適さを取り戻すのを手伝いましょう。',
    description: `執事のオースティンが家族の住むお屋敷に
      温かさと快適さを取り戻すのを手伝いましょう。一歩足を踏み入れた瞬間から
      冒険が始まります！`,
  },
  cookie: {
    message: '当サイトでは、サービスを向上するためにCookieを利用しています',
    link: `詳細`,
    button: '許可',
  },
  install: {
    title: '@:common.install',
    text: `ホームスケイプがデスクトップに登場！
    Web版をインストールして、わずか数クリックでオースティンに会いに行きましょう！`,
    button: '@:common.install',
  },
  copy: {
    xsolla: 'Xsollaはホームスケイプ公認のグローバルディストリビューターです',
  },
  game: {
    notSupported: `モバイルデバイスはサポート対象外です。コンピューターからログインしてプレイしてください。`,
  },
};
